import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

export default function CustomModal(props) {

  const [scroll, setScroll] = React.useState('body');



  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (
    <div>

      <Dialog
        open={props.open}
        onClose={props.handleClose}
        scroll={scroll}
        fullWidth={true}
        BackdropProps={{
            style: {
              background: 'rgba(255, 255, 255, 0.5)',
              backdropFilter: 'blur(5px)'
              }
          }}
        maxWidth={'lx'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
       
        <DialogContent dividers={false}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <div style={{display:'flex',marginBottom:20,flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                <div style={{flex:1,textAlign:'right'}}>
                    <img
                        src={`${require('../../../assets/imgs/mof.jpg')}`}
                        alt={"شركة السلام العامة"}
                        loading="lazy"
                        width={"150px"}
                    />
                </div >
                <div style={{flex:1}}>
                    <h3>فاتورة ضرية الدخل للمهن الطبية</h3>
                </div>
                <div style={{flex:1}}>
                    <img
                        src={`${require('../../../assets/imgs/moh.png')}`}
                        alt={"شركة السلام العامة"}
                        loading="lazy"
                        width={"150px"}
                    />
                </div>
            </div>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                <div style={{flex:1,textAlign:'right'}}>
                    
                    <div style={{display:'flex',textAlign:'right',flexDirection:'column',justifyContent:'space-between',alignItems: 'right',height:'200px'}}>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            <h3>المعلومات الشخصية</h3>
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/doctor.png')}`}
                                    alt={"دكتور"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>د. سيف أسماعيل الدباغ</h5>
                        
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/phone.png')}`}
                                    alt={"دكتور"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px',direction:'ltr'}}>+964 (770) 000-0000</h5>
                        
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/building.png')}`}
                                    alt={"دكتور"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>بغداد / السعدون - مجاور محطة تعبئة وقود السعدون</h5>
                        
                        </div>
                    </div>
                </div>
                <div style={{ 
                    flex:0.1,
                   
                    }}>

                </div>
                <div style={{ 
                    
                    border: '2px solid #2E5266',
                    borderRadius:'12px',
                    background: '#2E5266',
                    height: '220px'
                    }}>

                </div>
                <div style={{ 
                    flex:0.1,
                    
                    height: '200px'
                    }}>

                </div>
                <div style={{flex:1,textAlign:'right'}}>
                
                    <div style={{display:'flex',textAlign:'right',flexDirection:'column',justifyContent:'space-between',alignItems: 'right',height:'200px'}}>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            <h3>معلومات الفاتورة</h3>
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/hashtag.png')}`}
                                    alt={"تسلسل"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>التسلسل: 000001</h5>
                        
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/schedule.png')}`}
                                    alt={"التاريخ"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>00/00/0000 - 12:00:00</h5>
                        
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/printer.png')}`}
                                    alt={"دكتور"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>00/00/0000 - 12:00:00</h5>
                        
                        </div>
                    </div>
                </div>
            </div>
            <div style={{display:'flex',marginTop:'50px',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                <div style={{flex:1,textAlign:'right'}}>
                    
                    <div style={{display:'flex',textAlign:'right',flexDirection:'column',justifyContent:'space-between',alignItems: 'right',height:'200px'}}>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            <h3>تفاصيل الفاتورة</h3>
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/calendar.png')}`}
                                    alt={"التاريخ"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>00/00/0000 - 00/00/0000</h5>
                        
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/tax.png')}`}
                                    alt={"التاريخ"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>ضريبة دخل عن العمل في عيادة خاصة</h5>
                        
                        </div>
                        <div style={{display:'flex',textAlign:'right',flexDirection:'row',justifyContent:'space-between',alignItems: 'center'}}>
                            
                                <img
                                    src={`${require('../../../assets/imgs/online_shop.png')}`}
                                    alt={"دكتور"}
                                    loading="lazy"
                                    width={"40px"}
                                />
                                <h5 style={{width:'100%',marginRight:'10px'}}>1,345,000 دينار عراقي</h5>
                        
                        </div>
                    </div>
                </div>
                <div style={{flex:1,textAlign:'right'}}>
                        <div style={{display:'flex',textAlign:'right',alignItems: 'center',flexDirection:'row',justifyContent:'right',height:'200px'}}>
                            <Button variant="contained" 
                                sx={{
                                    fontFamily: " 'Tajawal', sans-serif",
                                    backgroundColor: '#2E5266',
                                    color: '#fff',
                                    fontSize: '20px',
                                    marginLeft:'20px',
                                    maxWidth:'30%',
                                    
                                    height:'50px',
                                    flex:1,
                                    '&:hover':{
                                        backgroundColor: '#FFFFFF',
                                        color: '#2E5266',
                                    },
                                    borderRadius: '14px'
                                    }}>
                                    ادفع الان
                            </Button>
                            <Button variant="contained" 
                                sx={{
                                    fontFamily: " 'Tajawal', sans-serif",
                                    backgroundColor: '#EAEEF1',
                                    color: '#2E5266',
                                    height:'50px',
                                    maxWidth:'30%',
                                    fontSize: '20px',
                                    
                                    flex:1,
                                    borderRadius: '14px',
                                    '&:hover':{
                                        backgroundColor: '#2E5266',
                                        color: '#EAEEF1',
                                    },
                                    }}>
                                    طباعة
                            </Button>
                        </div>
                    
                    </div>
                
            </div>
                        
          </DialogContentText>
        </DialogContent>
        
      </Dialog>
    </div>
  );
}
